var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.RecipeList,{attrs:{"recipes":_setup.results,"loading":_setup.isLoadingRecipeList,"preapplied-filters":_setup.filters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }